import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  IconButton,
  Menu,
  MenuItem,
  withStyles,
  CircularProgress,
  Tooltip,
} from '@material-ui/core'
import { Add, ArrowDropDown } from '@material-ui/icons'
import { bindActionCreators } from 'redux'
import { toggleDialog } from 'actions/view'
import * as routes from './routes'
import AddOrEditURL from './AddOrEditURL'
import BulkUploadStatus from './ContactsPage/BulkUploadStatus'
import { PencilPlus } from 'mdi-material-ui'

const styles = theme => ({
  button: {
    color: '#fff',
    marginRight: 8,
    position: 'relative', // Add this to make it a positioning context for the arrow
  },
  arrowIcon: {
    position: 'absolute',
    fontSize: '1rem',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none', // This ensures the arrow doesn't interfere with button clicks
  },
})

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const HeaderAddButton = ({
  classes,
  toggleDialog,
  location,
  push,
  loadingAllConversations,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [urlDialogOpen, setUrlDialogOpen] = useState(false)
  const [showBulkUploadStatus, setShowBulkUploadStatus] = useState(false)

  const route = Object.values(routes).find(route =>
    location.pathname.startsWith(route?.path),
  )

  const isInbox =
    !location.pathname ||
    location.pathname === '/' ||
    location.pathname.startsWith('/inbox')

  const handleClick = event => {
    if (isInbox) {
      toggleDialog({
        open: true,
        dialog: 'contactList',
        options: {
          type: 'inbox',
        },
      })
    } else if (route?.path === '/contacts') {
      setAnchorEl(event.currentTarget)
    } else if (route?.path === '/urls') {
      setUrlDialogOpen(true)
    } else if (route?.path === '/knowledge') {
      toggleDialog({
        open: true,
        dialog: 'AddOrEditKnowledge',
        options: { id: 'new' },
      })
    } else if (route) {
      push(
        route?.customAddPath
          ? route?.customAddPath
          : route?.addOrEditPath
          ? route?.addOrEditPath('new')
          : `/${route?.endpoint}s/new`,
      )
    } else {
      console.log('no route found')
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleAddContact = () => {
    push('/contacts/new')
    handleClose()
  }

  if (isInbox && loadingAllConversations) {
    return <CircularProgress className={classes.button} />
  }

  return (
    <>
      <Tooltip
        title={
          isInbox
            ? 'New message'
            : 'Add new' + (route?.path === '/contacts' ? ' or...' : '')
        }
      >
        <IconButton className={classes.button} onClick={handleClick}>
          {isInbox ? <PencilPlus /> : <Add />}
          {route?.path === '/contacts' && (
            <ArrowDropDown className={classes.arrowIcon} />
          )}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleAddContact}>Add New contact</MenuItem>
        {jwtToken ? (
          <MenuItem
            onClick={() => {
              handleClose()
              return window?.ReactNativeWebView?.postMessage?.(
                'contacts/import',
              )
            }}
          >
            Import contacts from device
          </MenuItem>
        ) : null}
        {jwtToken ? (
          <MenuItem
            onClick={() => {
              handleClose()
              return window?.ReactNativeWebView?.postMessage?.(
                'contacts/export',
              )
            }}
          >
            Download contacts from Vast Reach to device
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={() => {
            push('/contacts/upload')
            handleClose()
          }}
        >
          Upload CSV
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowBulkUploadStatus(true)
          }}
        >
          Show my contact uploads
        </MenuItem>
      </Menu>
      {showBulkUploadStatus ? (
        <BulkUploadStatus
          hideIt={() => {
            setShowBulkUploadStatus(false)
          }}
        />
      ) : null}
      {route?.path === '/urls' && (
        <AddOrEditURL
          open={urlDialogOpen}
          onOpen={() => setUrlDialogOpen(true)}
          onClose={() => setUrlDialogOpen(false)}
        />
      )}
    </>
  )
}

export default withStyles(styles)(
  connect(
    state => {
      return {
        loadingAllConversations:
          state.inbox.conversationsListCursor[
            state.inbox.conversationsListFilter
          ]?.loadingAll,
      }
    },
    dispatch => bindActionCreators({ toggleDialog }, dispatch),
  )(HeaderAddButton),
)
